import { get, post } from './http-calls';

export const getErrorFolders = async () => {
    let res = await get(`DocumentsReprocess/ErrorFolders`, { useAuthToken: true });
    return res;
};

export const getBranches = async (errorFolder) => {
    let res = await get(`DocumentsReprocess/Branches/${errorFolder}`, { useAuthToken: true });
    return res;
};

export const getDocumentTypes = async (errorFolder, branch) => {
    let res = await get(`DocumentsReprocess/DocumentTypes/${errorFolder}/${branch}`, { useAuthToken: true });
    return res;
};

export const getFiles = async (errorFolder, branch, documentType) => {
    let res = await get(`DocumentsReprocess/Files/${errorFolder}/${branch}/${documentType}`, { useAuthToken: true });
    return res;
};
export const Job_SearchByWIPAdmin = async (searchText) => {
    let res = await get(`DocumentsReprocess/Job_SearchByWIPAdmin/${searchText}`, { useAuthToken: true });
    return res;
};

export const processDocument = async (data) => {
    let res = await post(`DocumentsReprocess/ReProcessFiles`, data, { useAuthToken: true });
    return res;
};

export const DocumentsReprocessViewDocument = async (errorFolder, branchName, documentType, documentName) => {
    let res = await get(`DocumentsReprocess/ViewDocument/${errorFolder}/${branchName}/${documentType}/${documentName}`, {
        responseType: 'blob',
        returnOrgRes: true,
        useAuthToken: true
    });
    return window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf; charset=utf-8' }));
    // return window.URL.createObjectURL(new Blob([res.data]));
    // return res.data;
};

export const postDocumentsReprocessLinkToOtherJob = async (data) => {
    let res = await post(`DocumentsReprocess/LinkToOtherJob`, data, { useAuthToken: true });
    return res;
};

export const postDocumentsReprocessDeleteDocument = async (errorFolder, branchName, documentType, documentName) => {
    let res = await post(`DocumentsReprocess/DeleteDocument/${errorFolder}/${branchName}/${documentType}/${documentName}`, {}, { useAuthToken: true });
    return res;
};
